module.exports = __webpack_public_path__ + "img/4_EN_ChineseMicrosite_Homepage_HeroImage.5a6803ac.jpg";